import React from 'react';
import { Route } from 'react-router-dom';

const LoginLayoutRoute = ({ component, ...rest }) => {
  const Component = component;

  return (
    <Route
      {...rest}
      render={(props) => (
        <div>
          <Component {...props} />
        </div>
      )}
    />
  );
};

export default LoginLayoutRoute;
